export default [
{path:"/index",redirect:'/'},    
{
path: '/',
meta: {
    title: '运长安家',
    keepAlive: true
},
component: r => require.ensure([], () => r(require('../views/index/index')), `/`),
}, 
{
    path: '/fygl',
    meta: {
        title: '房源管理',
        keepAlive: true
    },
    component: r => require.ensure([], () => r(require('../views/index/fygl')), `/`),
}, 
{
    path: '/ele_entry',
    meta: {
        title: '电表入口',
        keepAlive: true
    },
    component: r => require.ensure([], () => r(require('../views/index/ele_entry')), `/`),
}, 
{
    path: '/news',
    meta: {
        title: '新闻资讯',
        keepAlive: true
    },
    component: r => require.ensure([], () => r(require('../views/index/news')), `/news`),
}, 

{
path: '/house/index',
meta: {
    title: '找房首页',
    keepAlive: true
},
component: r => require.ensure([], () => r(require('../views/house/index')), `/house/index`),
}, 
{
    path: '/house/searchlist',
    meta: {
        title: '搜索',
        keepAlive: false
    },
    component: r => require.ensure([], () => r(require('../views/house/searchlist')), `/house/searchlist`),
}, 
{
    path: '/house/map',
    meta: {
        title: '地图',
        keepAlive: false,
    },
    component: r => require.ensure([], () => r(require('../views/house/map')), `/house/map`),
}, 
{
    path: '/house/detail',
    meta: {
        title: '门店详情',
        keepAlive: false
    },
    component: r => require.ensure([], () => r(require('../views/house/detail')), `/house/detail`),
}, 

{
    path: '/post/index',
    meta: {
        title: '项目转让首页',
        keepAlive: false
    },
    component: r => require.ensure([], () => r(require('../views/post/index')), `/post/index`),
}, 
{
    path: '/post/post',
    meta: {
        title: '发布需求',
        keepAlive: true
    },
    component: r => require.ensure([], () => r(require('../views/post/post')), `/post/post`),
}, 
{
    path: '/post/content',
    meta: {
        title: '协议',
        keepAlive: false
    },
    component: r => require.ensure([], () => r(require('../views/post/content')), `/post/content`),
}, 
{
    path: '/post/my',
    meta: {
        title: '个人中心',
        keepAlive: false
    },
    component: r => require.ensure([], () => r(require('../views/post/my')), `/post/my`),
}, 
{
    path: '/post/postlist',
    meta: {
        title: '我的发布',
        keepAlive: false
    },
    component: r => require.ensure([], () => r(require('../views/post/postlist')), `/post/postlist`),
}, 
{
    path: '/post/detail',
    meta: {
        title: '帖子',
        keepAlive: false
    },
    component: r => require.ensure([], () => r(require('../views/post/detail')), `/post/detail`),
}, 



// {
//     path: '/error',
//     meta: {
//         title: '错误',
//     },
//     component: r => require.ensure([], () => r(require(`../views/error/index`)), `/error`),
// },

];


// WEBPACK FOOTER //
// ./src/router/config.js